import { Fragment, useState } from 'react'

import { useDispatch } from 'react-redux'

import { CoursePageHeaderProps } from '~/bootcamp/types/bootcamp.types'
import { Link } from '~/components/Link'
import { setBossCurrentBehavior } from '~/bootcamp/slices/bootcamp-quiz.slice'
import { BossBehaviors } from '~/bootcamp/Activities/types/activities.types'
import { QuizIcon } from '~/bootcamp/components/VideoCourseIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'

const QuizPageHeader = ({
  path,
  isCompleted,
  isCollapsed,
  title,
  isExpanded,
  onClick,
}: Exclude<CoursePageHeaderProps, 'type'>): React.ReactElement => {
  const [hasReloaded, setHasReloaded] = useState(false)
  const dispatch = useDispatch()
  const backgroundClasses = isCompleted
    ? 'bg-gradient-orange-to-violet'
    : `bg-gradient-purple-blue before:-z-1 before:absolute before:inset-0 before:bg-gradient-purple-light before:rounded-t before:opacity-0 lg:hover:before:opacity-100 before:transition-opacity before:duration-300`
  const className = `w-full mt-8 cursor-pointer ${
    isExpanded && !isCollapsed ? 'rounded-t' : 'rounded'
  } p-2.5 flex items-center min-h-16 z-1 relative text-white ${backgroundClasses}`

  const onHeaderClick = (): void => {
    onClick()

    if (isExpanded && !hasReloaded) {
      dispatch(setBossCurrentBehavior(BossBehaviors.RELOAD))
      setHasReloaded(true)
    }
  }

  const heading = (
    <Fragment>
      <QuizIcon isCompleted={isCompleted} size="large" />
      <span className="text-xl font-bold flex-1 mx-4 drop-shadow-lg">{title}</span>
      <span
        className={`transform transition-transform duration-300 ${
          isExpanded && !isCollapsed ? 'rotate-90' : 'rotate-0'
        }`}
      >
        <SVGIcon icon={ChevronRightIcon} pathClassName="text-white" />
      </span>
    </Fragment>
  )

  // Remove link for selected page
  if (isExpanded) {
    return (
      <div className={className} onClick={onHeaderClick}>
        {heading}
      </div>
    )
  }

  return (
    <Link className={className} onClick={onHeaderClick} replace scroll={false} shallow to={path}>
      {heading}
    </Link>
  )
}

export default QuizPageHeader
